import { updatesItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">最新快讯</h2>
          <p className="text-foreground-500 text-sm mt-2">网红圈24小时滚动快讯，重要事件绝不遗漏</p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300">
            {updatesItems.map((item) => (
              <div key={item.id} className="relative mb-6 last:mb-0">
                <span className="absolute -left-[calc(2rem+5px)] top-1 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-100"></span>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-1">
                  <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">{item.date}</span>
                  <span className={`px-2 py-0.5 text-xs rounded whitespace-nowrap inline-block w-fit ${
                    item.tag === '突发' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '翻车' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>{item.tag}</span>
                </div>
                <p className="text-sm text-foreground-800 leading-relaxed">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}